import React from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import { get } from 'utils/api-routes.util'
import PlusIcon from 'utils/icons/plus-icon'

import AddNewTagForm from './components/AddNewTagForm'
const columns = [
  {
    dataKey: 'tag_name',
    name: 'Tag Name',
    sortable: true,
    selector: (row) => (row.tag_name ? row.tag_name : '--'),
  },
  {
    dataKey: 'tag_description',
    name: 'Tag Description',
    sortable: true,
    selector: (row) => (row.tag_description ? row.tag_description : '--'),
  },
  {
    dataKey: 'order_count',
    name: 'Order Count',
    sortable: true,
    selector: (row) => (row.order_count ? row.order_count : '0'),
  },
]
const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Order Tags',
    active: true,
  },
]
const OrderTags = () => {
  const [tags, setTags] = React.useState<any>([])
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)

  const getSources = () => {
    setTableLoading(true)
    get('/settings/order/tags').subscribe((res: any) => {
      setTags(res.response.data)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getSources()
  }, [])

  const handleCloseModal = (data: any, action) => {
    if (action === 'add') {
      data.order_count = 0
      setTags([data, ...tags])
    } else if (action === 'update') {
      // can be used in future if decided to add update as-well
      // const newTags = tags.map((source) => {
      //   if (source.status_id === data.status_id) {
      //     return data;
      //   }
      //   return source;
      // });
      // setTags(newTags);
    }
    setShowNewModal(false)
  }

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <PixelFlexBox
              justifyContent="flex-end"
              width="100%"
              height="auto"
              padding=" 5px 20px "
            >
              <DcButton size="sm" onClick={() => setShowNewModal(true)}>
                <PlusIcon color="white" size={18} /> Add {!isMobile && 'Tag'}
              </DcButton>
            </PixelFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
          isMobile={isMobile}
        >
          <SectionContent isMobile={isMobile}>
            <PixelTable
              columns={columns}
              data={tags}
              progressPending={tableLoading}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 212px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      <DcOverlaySlider
        title={`Add Order Tag
        `}
        onClose={() => setShowNewModal(false)}
        isOpen={showNewModal}
        width="40%"
      >
        <SectionContent>
          {showNewModal && <AddNewTagForm handleClose={handleCloseModal} />}
        </SectionContent>
      </DcOverlaySlider>
    </>
  )
}

export default OrderTags
